import { render } from "./HeroSection.vue?vue&type=template&id=7823ae2e&scoped=true"
import script from "./HeroSection.vue?vue&type=script&lang=js"
export * from "./HeroSection.vue?vue&type=script&lang=js"

import "./HeroSection.vue?vue&type=style&index=0&id=7823ae2e&lang=scss&scoped=true"

import exportComponent from "/tmp/build_c77b6d3d/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7823ae2e"]])

export default __exports__